import React from 'react'
import actions from '../reducers/actions/index'
import { connect } from 'react-redux'
import { TextField, Button, Typography, Avatar, CssBaseline, CircularProgress } from '@material-ui/core'
import { LockOutlined } from '@material-ui/icons'
import { withStyles } from '@material-ui/styles'
import ForgotModal from '../components/ForgotModal'

class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    this.onPasswordChange = this.onPasswordChange.bind(this)
    this.onUsernameChange = this.onUsernameChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.hideForgotModal = this.hideForgotModal.bind(this)
		
    this.state = { username: '', password: '', errorMsg: null, fetching: false, showForgotModal: false }
  }
	
  componentDidMount() {
    document.title = 'Martz Bros Login'
  }
	
  onUsernameChange(e) {
    this.setState({ username: e.target.value })
  }
	
  onPasswordChange(e) {
    this.setState({ password: e.target.value })
  }
	
  onSubmit(e) {
    e.preventDefault()
    const { login } = this.props
    const { username, password } = this.state
    this.setState({ errorMsg: null, fetching: true })
    login(username, password)
      .then(() => History.push('/'))
      .catch(({ response }) => {
        if (response && response.statusCode === 401) {
          this.setState({ errorMsg: 'Invalid credentials', fetching: false })
        } else {
          this.setState({ errorMsg: 'There was an issue signing in', fetching: false })
        }
      })
  }

  hideForgotModal() {
    this.setState({ showForgotModal: false })
  }

  render() {
    const { classes } = this.props
    const { username, password, errorMsg, fetching } = this.state
    return (
      <div className={classes.body}>
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlined />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          {
            errorMsg ? (
              <Typography color="error">
                { errorMsg }
              </Typography>
            ) : null
          }
          <form className={classes.form} noValidate onSubmit={this.onSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={this.onUsernameChange}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={this.onPasswordChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={fetching}
            >
              {
                fetching ? (
                  <CircularProgress color="inherit"/>
                ) : 'Sign In'
              }
            </Button>
          </form>
          <div 
            style={{ marginTop: 10, textDecoration: 'underline', cursor: 'pointer', color: 'blue' }}
            onClick={() => this.setState({ showForgotModal: true })}
          >
            Forgot Password?
          </div>
        </div>
        <ForgotModal showModal={this.state.showForgotModal} hideModal={this.hideForgotModal} />
      </div>
    )
  }
}

const styles = {
  '@global': {
    body: {
      margin: 0,
      backgroundColor: '#f5f5f5',
      width: '100%',
      height: '100%'
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 500,
    margin: 'auto',
    marginTop: 200
  },
  avatar: {
    margin: 10
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  submit: {
  },
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default withStyles(styles)(connect(mapStateToProps, actions)(LoginPage))